<template>
  <v-dialog
    v-model="showDialog"
    max-width="600"
    @click:outside="closeDialog"
    @keydown.esc="closeDialog"
  >
    <v-card>
      <v-card-title class="justify-center text-uppercase headline">
        {{ chapterItem.id ? 'Update' : 'Add' }} Chapter
      </v-card-title>
      <v-divider />
      <div class="px-10 pb-5">
        <v-form ref="chapter-form" @submit.prevent>
          <div class="d-flex">
            <ant-input class="mr-5 flex-1" label="Chapter">
              <template #input-field>
                <v-text-field
                  v-model="chapterItem.chapter"
                  :disabled="
                    wkbLibraryTableStatus === 'loading' || headChapter !== null
                  "
                  :min="0"
                  :rules="[rules.required]"
                  dense
                  filled
                  hide-details
                  placeholder="Chapter"
                  type="number"
                />
              </template>
            </ant-input>

            <ant-input
              :is-optional="!headChapter"
              class="flex-1"
              label="Chapter"
            >
              <template #input-field>
                <v-text-field
                  v-model="chapterItem.sub_chapter"
                  :disabled="
                    wkbLibraryTableStatus === 'loading' ||
                    chapterItem.chapter === null
                  "
                  :min="0"
                  :rules="headChapter ? [rules.required] : []"
                  dense
                  filled
                  hide-details
                  placeholder="Subchapter"
                  type="number"
                />
              </template>
            </ant-input>
          </div>

          <ant-input label="Title">
            <template #input-field>
              <v-text-field
                v-model="chapterItem.title"
                :disabled="wkbLibraryTableStatus === 'loading'"
                :rules="[rules.required]"
                dense
                filled
                hide-details
                placeholder="Title"
              />
            </template>
          </ant-input>
        </v-form>
      </div>
      <v-card-actions class="ant-border-top ant-dialog-actions-bg">
        <v-spacer />
        <v-btn
          :disabled="wkbLibraryTableStatus === 'loading'"
          class="mx-2"
          color="error"
          small
          text
          @click="closeDialog"
          >cancel
        </v-btn>
        <v-btn
          :disabled="wkbLibraryTableStatus === 'loading'"
          :loading="wkbLibraryTableStatus === 'loading'"
          color="primary"
          small
          @click="saveOrUpdateChapter"
          >{{ chapterItem.id ? 'update' : 'create' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import AntInput from '@/components/AntInput.vue';

export default {
  name: 'DhmeWkbChapterDialog',
  components: { AntInput },
  props: {
    displayed: {
      type: Boolean,
      required: true,
    },
    headChapter: {
      type: Object,
      required: false,
      default: null,
    },
    updateChapter: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data: () => {
    return {
      chapterItem: {},
      rules: {
        required: (value) => !!value || 'Required.',
      },
    };
  },
  computed: {
    ...mapGetters(['wkbLibraryTableStatus']),
    showDialog() {
      return this.displayed;
    },
  },
  watch: {
    headChapter(value) {
      if (value) {
        this.chapterItem.chapter = value.chapter;
      }
    },
    updateChapter(value) {
      if (value) {
        this.chapterItem = Object.assign({}, value);
      }
    },
  },
  methods: {
    closeDialog() {
      this.chapterItem = Object.assign({}, {});
      this.$refs['chapter-form'].reset();
      this.$emit('closeDialog');
    },
    saveOrUpdateChapter() {
      if (this.$refs['chapter-form'].validate()) {
        if (this.chapterItem.id) {
          // update item
          const recordId = this.chapterItem.id;
          delete this.chapterItem.id;
          this.$store
            .dispatch('updateWkbLibraryRecord', {
              table: 'CFFA_DHME_WKB_CHAPTERS',
              recordId,
              body: {
                record: this.chapterItem,
              },
            })
            .then(() => {
              this.closeDialog();
            });
        } else {
          // create item
          this.$store
            .dispatch('createWkbLibraryRecord', {
              table: 'CFFA_DHME_WKB_CHAPTERS',
              body: {
                record: this.chapterItem,
              },
            })
            .then(() => {
              this.closeDialog();
            });
        }
      }
    },
  },
};
</script>

<style scoped></style>
